module.exports = __webpack_public_path__ + "img/mimg03.e9223554.jpg";